import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as gameActions from '../../Core/Game/game.actions'

import SettingsMenuButton from '../../Mars/Settings/SettingsMenuButton'

const FinishTutorialScreen = ({ setScreens }) => (
  <main className="main" role="main">
    <SettingsMenuButton />
    <div className="container background--mina__canvas">
      <div className="content">
        <div className="tutorial--welcome">
          <h1 className="h1">
            <span className="name">
              <FormattedMessage id="tutorial.turn5.academy_text1.title" />
            </span>
          </h1>
          <p>
            <FormattedMessage id="tutorial.turn5.academy_text1.p1" />
          </p>
          <p>
            <FormattedMessage id="tutorial.turn5.academy_text1.p2" />
          </p>
          <p>
            <FormattedMessage id="tutorial.turn5.academy_text1.p3" />
          </p>
          <div
            className="btn--orange"
            onClick={() => {
              setScreens(['veredict_tutorial_screen'])
            }}
          >
            <span className="icon-rocket"></span>
            <span>
              <FormattedMessage id="tutorial.turn5.academy_text1.end_button" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </main>
)

FinishTutorialScreen.propTypes = {
  setScreens: PropTypes.func,
}

const mapDispatchToProps = (dispatch) => ({
  setScreens: bindActionCreators(gameActions.setScreens, dispatch),
})

export default connect(null, mapDispatchToProps)(injectIntl(FinishTutorialScreen))
